import React from 'react';
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';


const Projects = ({project, img}) => {
    return (
        <div className='link-out'>
            <div className='box-outline'>
                <a href={project.link} target='_blank' rel="noopener noreferrer">
                    <i aria-hidden='true'> <FaExternalLinkAlt /></i>
                </a>
                <a href={project.github} target='_blank' rel="noopener noreferrer">
                    <i aria-hidden='true'><FaGithub /></i>
                </a>
                <div className='position-relative'>
                    <a href={project.link} target='_blank' rel="noopener noreferrer">
                    <img src={require (`../images/${img}`)} alt='project'/>
                <div className='project-overlay'>
                    <h2 className='project-title'>{project.title}</h2>
                    <p className='project-description'>{project.description}</p>
                </div>
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Projects;
